import React, { Component } from 'react';
import { Modal, Button, Row } from 'antd/lib';
import { withApollo } from 'react-apollo';

import Uploader from './Uploader';

class ModalUploader extends Component {
  handleOk = e => {
    this.props.ocultarModalUploader();
  };

  render() {
    return (
      <div>
        <Modal
          title="Subir un Documento Digital"
          visible={this.props.mostrarModalUploader}
          onCancel={this.props.ocultarModalUploader}
          onOk={this.handleOk}
          width={800}
          style={{ width: 600 }}
          footer={[
            <Button key="back" onClick={this.props.ocultarModalUploader}>
              Volver
            </Button>,
          ]}
        >
          <Row>
            <Uploader
              ocultar={this.props.ocultarModalUploader}
              acuerdo={this.props.acuerdo}
              actualizarTabla={this.props.actualizarTabla}
            />
          </Row>
        </Modal>
      </div>
    );
  }
}

export default withApollo(ModalUploader);
